var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    }
    else {
        cooked.raw = raw;
    }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import './AuthForm.scss';
import { useForm, useWatch } from 'react-hook-form';
import PasswordEye from '@assets/svg/eye.svg';
import PasswordEyeOff from '@assets/svg/eyeOff.svg';
import ErrorIcon from '@assets/svg/ErrorIcon.svg';
import { useAppDispatch } from '@/hooks/redux';
import { setCurrentUser, setToken } from '@/store/slices/authSlice';
import { useLazyGetProfileQuery, useLoginMutation } from '@/services/baseApi';
import Loader from '@/components/Loader/Loader';
import CenterModal from '@/components/CenterModal/CenterModal';
import { styled } from 'styled-components';
var AuthForm = function () {
    var _a = useForm(), register = _a.register, handleSubmit = _a.handleSubmit, control = _a.control, errors = _a.formState.errors;
    var _b = useState(false), showPassword = _b[0], setShowPassword = _b[1];
    var _c = useState(false), showErrorModal = _c[0], setShowErrorModal = _c[1];
    var _d = useState(null), errorMessage = _d[0], setErrorMessage = _d[1];
    var dispatch = useAppDispatch();
    var _e = useLoginMutation(), loginFn = _e[0], _f = _e[1], error = _f.error, isLoading = _f.isLoading, isSuccess = _f.isSuccess;
    var getProfile = useLazyGetProfileQuery()[0];
    var loginWatcher = useWatch({
        control: control,
        name: 'login',
        defaultValue: '',
    });
    var passwordWatcher = useWatch({
        control: control,
        name: 'password',
        defaultValue: '',
    });
    useEffect(function () {
        if (error) {
            console.log('Ошибка при логине:', error); // Лог для проверки ошибки
            setShowErrorModal(true);
            var timer_1 = setTimeout(function () {
                setShowErrorModal(false);
            }, 3000);
            return function () { return clearTimeout(timer_1); };
        }
    }, [error]);
    var Submit = function (dataForm) {
        return __awaiter(void 0, void 0, void 0, function () {
            var response, res, errorMsg, error_1;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, loginFn({
                                login: dataForm.login,
                                password: dataForm.password,
                            })];
                    case 1:
                        response = _d.sent();
                        console.log('RES', response); // Лог для проверки структуры ответа
                        if (!(response && response.data && response.data.access_token))
                            return [3 /*break*/, 3];
                        dispatch(setToken(response.data.token)); // Передаем сам токен
                        localStorage.setItem('token', response.data.access_token);
                        return [4 /*yield*/, getProfile({})];
                    case 2:
                        res = _d.sent();
                        dispatch(setCurrentUser(res.data));
                        return [3 /*break*/, 4];
                    case 3:
                        if (response.error) {
                            errorMsg = (_a = response.error.data) === null || _a === void 0 ? void 0 : _a.message;
                            console.log('Сообщение об ошибке:', errorMsg); // Лог для проверки сообщения
                            if (errorMsg === 'User is blocked') {
                                setErrorMessage('Ваш аккаунт заблокирован. Пожалуйста, свяжитесь с поддержкой.');
                            }
                            else {
                                setErrorMessage('Неверные учетные данные. Пожалуйста, проверьте логин и пароль.');
                            }
                            setShowErrorModal(true);
                        }
                        _d.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_1 = _d.sent();
                        console.error('Ошибка в блоке catch:', error_1); // Лог для проверки ошибок
                        if (((_c = (_b = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) === 'User is blocked') {
                            setErrorMessage('Произошла ошибка. Вы были заблокированы вышестоящим пользователем.');
                        }
                        else {
                            setErrorMessage('Произошла ошибка при попытке входа. Пожалуйста, попробуйте еще раз.');
                        }
                        setShowErrorModal(true);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    return (_jsxs(_Fragment, { children: [_jsx(CenterModal, __assign({ show: showErrorModal, handleClose: function () { return setShowErrorModal(false); } }, { children: _jsxs(ModalSuccessContent, { children: [_jsx(ErrorIcon, {}), errorMessage] }) })), _jsx("form", __assign({ onSubmit: handleSubmit(Submit), className: "AuthForm" }, { children: isLoading ? (_jsx(Loader, { width: "100px", height: "100px" })) : (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "wrapperField" }, { children: _jsx("input", __assign({}, register('login', { required: true }), { className: "AuthInput ".concat(loginWatcher.trim() !== '' ? 'notEmpty' : ''), style: error ? { borderColor: '#EB5757' } : {}, type: "text", placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043B\u043E\u0433\u0438\u043D" })) })), _jsxs("div", __assign({ className: "wrapperField" }, { children: [_jsx("input", __assign({}, register('password', { required: true }), { placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C", style: error ? { borderColor: '#EB5757' } : {}, type: showPassword ? 'text' : 'password', className: "AuthInput ".concat(passwordWatcher ? 'notEmpty' : '') })), !showPassword ? (_jsx(PasswordEye, { onClick: function () { return setShowPassword(!showPassword); }, className: "passwordEye ".concat(showPassword ? 'show' : '') })) : (_jsx(PasswordEyeOff, { onClick: function () { return setShowPassword(!showPassword); }, className: "passwordEye ".concat(showPassword ? 'show' : '') }))] })), _jsx("div", __assign({ className: "wrapperField" }, { children: _jsx("button", __assign({ className: "AuthInput", type: "submit", value: "\u0412\u043E\u0439\u0442\u0438", style: { background: '#E621D3', color: '#fff', cursor: 'pointer' } }, { children: "\u0412\u043E\u0439\u0442\u0438" })) }))] })) }))] }));
};
var ModalSuccessContent = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 40px;\n  text-align: center;\n  width: 28vw;\n  display: flex;\n  font-family: 'Montserrat Regular';\n  font-weight: 500;\n  font-size: 20px;\n  gap: 20px;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  @media (max-width: 768px) {\n    width: 80vw;\n    padding: 16px;\n  }\n"], ["\n  margin-top: 40px;\n  text-align: center;\n  width: 28vw;\n  display: flex;\n  font-family: 'Montserrat Regular';\n  font-weight: 500;\n  font-size: 20px;\n  gap: 20px;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  @media (max-width: 768px) {\n    width: 80vw;\n    padding: 16px;\n  }\n"])));
export default AuthForm;
var templateObject_1;
